<script lang="ts">
    import Label from "./Label.svelte";
    export let placeholder = "";
    export let id = "";
    export let label_text = "";
    export let required: boolean = false;
    export let value;
    export const focus = ()=>{input_element.focus()};

    let input_element;
</script>

<input required={required} bind:this="{input_element}" bind:value="{value}" {...$$restProps} {placeholder} type="password" {id} class="validate">
{#if label_text && id}
  <Label label_for={id} {label_text}></Label>
{/if}